import { validate as emailValidate } from "email-validator";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import { login } from "../../api";
import { getOrgOrGeneralUrl } from "../../helpers";
import { LoginStore } from "../../store/login";
import { OrgStore } from "src/store";
import { getQueryParam } from "src/utils";

import { AlternateLink } from "./alternate_link";
import { EmailInput } from "./email_input";
import { ErrorMessage } from "./error_message";
import { LoginForm } from "./login_form";
import { PasswordInput } from "./password_input";
import { SubmitButton } from "./submit_button";

const EmailLoginForm = () => {
  const { orgIdentifier } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const { data, loading, error } = useSelector(LoginStore.sliceSelectors.select());
  const emailQueryParam = getQueryParam("email");
  const defaultValues = { realemail: emailQueryParam || data.email };
  const org = useSelector(OrgStore.selectors.find({ short_name: orgIdentifier }));

  useEffect(() => {
    if (emailQueryParam) {
      dispatch(LoginStore.actions.update({ email: emailQueryParam }));
    }
  }, [dispatch, emailQueryParam]);

  const onEmailFormSubmit = () => ({ realemail, realpassword }) => {
    dispatch(LoginStore.actions.update({ email: realemail }));
    dispatch(login({ email: realemail, password: realpassword, "org-id": org?.id }));
  };

  const onForgotPasswordClick = ({ getValues }) => () => {
    const email = getValues("realemail");
    if (email && emailValidate(email)) {
      dispatch(LoginStore.actions.update({ email }));
    }
    dispatch(LoginStore.actions.clearError());
    dispatch(LoginStore.actions.update({ contextualMessage: null }));
    history.push(getOrgOrGeneralUrl(orgIdentifier, "request-password-reset"));
  };

  return (
    <LoginForm onSubmit={onEmailFormSubmit} defaultValues={defaultValues}>
      <EmailInput />
      <PasswordInput />
      <AlternateLink
        text="Forgot Password"
        onClick={onForgotPasswordClick}
        id="js-forgot-password"
      />
      <SubmitButton loading={loading} text="Sign In" />
      {error ? <ErrorMessage msg={error} /> : null}
    </LoginForm>
  );
};

export { EmailLoginForm };
